import api from '../lib/api'

export const listProducts = (tenantId, params = {}) =>
    api.get(`/admin/products/${tenantId}`, { params }).then(r => r.data)

export const listCategories = (tenantId) =>
    api.get(`/admin/products/${tenantId}/categories`).then(r => r.data)

export const createProduct = (tenantId, data) =>
    api.post(`/admin/products/${tenantId}`, data).then(r => r.data)

export const updateProduct = (tenantId, productId, data) =>
    api.patch(`/admin/products/${tenantId}/${productId}`, data).then(r => r.data)

export const deleteProduct = (tenantId, productId) =>
    api.delete(`/admin/products/${tenantId}/${productId}`).then(r => r.data)

export const uploadProductImage = (tenantId, productId, file) => {
    const form = new FormData()
    form.append('file', file)
    return api.post(`/admin/products/${tenantId}/${productId}/images/upload`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data)
}

export const deleteProductImage = (tenantId, productId, url) =>
    api.delete(`/admin/products/${tenantId}/${productId}/images`, { params: { url } }).then(r => r.data)

export const getTenantInfo = (tenantId) =>
    api.get(`/admin/tenants/${tenantId}/info`).then(r => r.data)
